// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import axios from 'axios'

import { getAccessToken } from '@/services/auth/token-provider'

const API_URL = import.meta.env.VITE_API_URL

interface RPC {
  request(
    service: string,
    method: string,
    contentType: 'application/json' | 'application/protobuf',
    data: Record<string, unknown> | Uint8Array
  ): Promise<Record<string, unknown> | Uint8Array>
}

const client = axios.create({
  baseURL: `${API_URL}/twirp`,
})

client.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken()
    if (token && config.headers) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => Promise.reject({ error })
)

export const axiosRPC: RPC = {
  async request(service, method, contentType, data) {
    const res = await client.post(`${service}/${method}`, data, {
      responseType:
        contentType === 'application/protobuf' ? 'arraybuffer' : 'json',
      headers: { 'content-type': contentType },
    })
    return res?.data
  },
}
